import script from "./Storehouse.vue?vue&type=script&setup=true&lang=ts"
export * from "./Storehouse.vue?vue&type=script&setup=true&lang=ts"

import "./Storehouse.vue?vue&type=style&index=0&id=b3c1049e&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3c1049e"]])

export default __exports__